var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovingBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376,
    height: 159.499,
    viewBox: "0 0 376 159.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "header_banner",
    transform: "translate(-246.867 -97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57943",
    "data-name": "Group 57943",
    transform: "translate(232 114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11649",
    "data-name": "Rectangle 11649",
    width: 376,
    height: 139,
    rx: 5,
    transform: "translate(14.867 -17)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_60",
    "data-name": "Union 60",
    d: "M13937.944,1099.5a3.448,3.448,0,1,1,3.447,3.5A3.475,3.475,0,0,1,13937.944,1099.5Zm-28.945,0a3.448,3.448,0,1,1,3.447,3.5A3.474,3.474,0,0,1,13909,1099.5Z",
    transform: "translate(-13724.133 -961)",
    fill: "#bdc7cf",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53674",
    "data-name": "Path 53674",
    d: "M0,0H178",
    transform: "translate(113.867 6.948)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_406",
    "data-name": "Line 406",
    x2: 95,
    transform: "translate(155.43 24.666)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58037",
    "data-name": "Group 58037",
    transform: "translate(64.13 18.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57944",
    "data-name": "Group 57944",
    transform: "translate(75 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53600",
    "data-name": "Path 53600",
    d: "M302.208,115.474,268.9,82.166a4.566,4.566,0,0,0-6.458,0L220,124.608h92.427Z",
    transform: "translate(-184.828 -78.531)",
    fill: "#e7e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53602",
    "data-name": "Path 53602",
    d: "M236.333,86.6,204.6,117.89a4.542,4.542,0,0,0,3.2,1.315h63.94L243.206,86.6A4.568,4.568,0,0,0,236.333,86.6Z",
    transform: "translate(-204.598 -73.128)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_833",
    "data-name": "Ellipse 833",
    cx: 7.153,
    cy: 7.409,
    rx: 7.153,
    ry: 7.409,
    transform: "translate(45.984 0)",
    fill: "#e7e9ed"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_838",
    "data-name": "Ellipse 838",
    cx: 3.446,
    cy: 3.5,
    rx: 3.446,
    ry: 3.5,
    transform: "translate(199.65 135)",
    fill: "#1a2d4c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingBanner);
export default __webpack_public_path__ + "static/media/movingBanner.4605efb0c168a1432b96377244bca3bc.svg";
export { ForwardRef as ReactComponent };